import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'what_is_the_age_of_the_youngest_worker_in_the_fac'

export const dataPointDefinition = {
  retracedId: 'what_is_the_age_of_the_youngest_worker_in_the_fac',
  name: 'What is the age of the youngest worker in the facility?',
  description:
    'The intent of this question is to understand the age of the facility\'s youngest worker. \r\r\n\r\r\nFor example, if the youngest worker in the facility is 17 years old, the response selection of "17" should be chosen. If the worker is 16 years and 11 months old, the response of "16" should be chosen. If the worker is 18 years and 11 months old you still select "18". \r\r\n\r\r\nOnly if the worker is 19 or older or 11 or younger, then select "Other". ',
  meta: {},
  fieldTypeId: 'SELECT_WITH_FOLLOW_UP',
  type: 'RELATIONAL',
  options: [
    {
      name: 12,
      key: 'AGES_12',
      slcpIndex: 1,
      slcpOptionName: 'ages',
    },
    {
      name: 13,
      key: 'AGES_13',
      slcpIndex: 2,
      slcpOptionName: 'ages',
    },
    {
      name: 14,
      key: 'AGES_14',
      slcpIndex: 3,
      slcpOptionName: 'ages',
    },
    {
      name: 15,
      key: 'AGES_15',
      slcpIndex: 4,
      slcpOptionName: 'ages',
    },
    {
      name: 16,
      key: 'AGES_16',
      slcpIndex: 5,
      slcpOptionName: 'ages',
    },
    {
      name: 17,
      key: 'AGES_17',
      slcpIndex: 6,
      slcpOptionName: 'ages',
    },
    {
      name: 18,
      key: 'AGES_18',
      slcpIndex: 7,
      slcpOptionName: 'ages',
    },
    {
      name: 'Other',
      key: 'AGES_OTHER',
      slcpIndex: 8,
      slcpOptionName: 'ages',
      followUp: {
        fieldType: 'NUMBER',
        text: 'If other, please describe:',
        externalIds: [
          {
            id: 'cl-1--2-8f',
            version: '1.4.0',
            provider: 'slcp',
          },
        ],
      },
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'object',
        properties: {
          value: {
            type: 'string',
            enum: ['AGES_12', 'AGES_13', 'AGES_14', 'AGES_15', 'AGES_16', 'AGES_17', 'AGES_18', 'AGES_OTHER'],
          },
          followUp: {
            type: ['object', 'null'],
            properties: {
              value: {
                type: 'string',
              },
            },
            required: ['value'],
          },
        },
        required: ['value', 'followUp'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'cl-1--2',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 4420,
  sectionId: '2.2.1',
  impactArea: 'Child Labour',
  impactAreaId: 'CHILD_LABOR',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
